import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import palette from './palette'

const theme = createTheme({
  palette,
  direction: 'rtl',
  spacing: 2,
  typography: {
    allVariants: {
      fontFamily: 'IRANSans',
    },
    h1: {
      fontSize: 24,
      fontWeight: 630
    },
    h3: {
      fontSize: 20,
      fontWeight: 520
    },
    h4: {
      fontSize: 17,
      fontWeight: 500
    },
    h5: {
      fontSize: 14.4,
      fontWeight: 450
    },
    h6: {
      fontSize: 13.4,
      fontWeight: 390
    },
    body1: {
      fontSize: 15,
      fontWeight: 480
    },
    body2 : {
      fontSize: 13.5,
      fontWeight: 400
    } ,
    button: {
      fontSize: 16,
      marginTop: 10,
    },
  },
})

export default responsiveFontSizes(theme)
